<template>
	<v-switch
		:modelValue="modelValue"
		:inset="inset"
		:color="color"
		:hideDetails="hideDetails"
		:label="modelValue ? labelOn : labelOff"
		class="ao-switch"
		@update:modelValue="onUpdateModelValue"
	/>
</template>

<script setup>
// import { computed } from 'vue'

/* const props =  */ defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	color: {
		type: String,
	},
	inset: {
		type: Boolean,
		default: true,
	},
	hideDetails: {
		type: [Boolean, String], // boolean | 'auto'
		default: 'auto',
	},

	/* Не вижу смысла для него */
	// custom: {
	// 	type: String,
	// 	default: null,
	// 	// TODO: add validation
	// },
	labelOn: {
		type: String,
		default: '',
	},
	labelOff: {
		type: String,
		default: '',
	},
})

const emit = defineEmits({
	'update:modelValue': null,
})

// const computedProps = computed(() => {
// 	const returnedProps = {}
// 	if (props.color) returnedProps.color = props.color
// 	return returnedProps
// })

const onUpdateModelValue = (value) => {
	emit('update:modelValue', value)
}

// const customClass = computed(() => {
// 	let prefix = 'ao-custom-switch-'
// 	let customClass = ''
// 	if (this.custom) {
// 		customClass = prefix + this.custom
// 	}
// 	return customClass
// })
</script>

// .v-switch--inset .v-switch__track
<style lang="scss">
.ao-switch {
	&.v-switch--inset {
		.v-switch__track {
			width: 28px;
			height: 16px;
			opacity: 0.2;
		}

		.v-selection-control__input {
			transform: translateX(-5px);
		}

		.v-switch__thumb {
			width: 12px;
			height: 12px;
		}
	}

	.v-selection-control--density-default {
		--v-selection-control-size: 32px;
	}

	.v-selection-control {
		min-height: 28px !important;
	}

	.v-selection-control--dirty {
		.v-switch__track {
			opacity: 1;
		}

		.v-selection-control__input {
			transform: translateX(5px) !important;
		}
	}

	.v-switch__thumb {
		color: rgb(var(--v-theme-white)) !important;
	}

	.v-label {
		padding-inline-start: 0.5rem !important;
		font-size: 0.75rem;
		color: #576674;
	}

	.v-progress-circular {
		width: 10px !important;
		height: 10px !important;
	}
}
</style>
